import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "../../firebase";
import CustomInput from "../../components/CustomInput/CustomInput";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";

const ResetPasswordScreen = () => {
  const { control, handleSubmit, watch } = useForm();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [oobCode, setOobCode] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const password = watch("password");

  useEffect(() => {
    const code = searchParams.get("oobCode");
    if (!code) {
      alert(t("reset_password.invalid_link"));
      navigate("/login");
    } else {
      setOobCode(code);
    }
  }, [searchParams, t, navigate]);

  const onSubmit = async (data) => {
    try {
      await confirmPasswordReset(auth, oobCode, data.password);
      setSuccessMessage(t("reset_password.success"));
    } catch (error) {
      alert(t("reset_password.error"));
    }
  };

  return (
    <>
      <Header />
      <div
        className="reset-container"
        style={{ marginTop: "10rem", marginBottom: "10rem" }}
      >
        <h2>{t("reset_password.title")}</h2>

        {successMessage ? (
          <div className="alert alert-success" role="alert">
            {successMessage}
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="reset-form">
            <CustomInput
              name="password"
              control={control}
              placeholder={t("reset_password.new_password")}
              isPassword
              secureTextEntry
              showPasswordGuide
              rules={{
                required: t("reset_password.password_required"),
                validate: (value) =>
                  /[A-Z]/.test(value) || t("custom_input.uppercase"),
              }}
            />

            <CustomInput
              name="confirmPassword"
              control={control}
              placeholder={t("reset_password.confirm_password")}
              isPassword
              secureTextEntry
              rules={{
                required: t("reset_password.confirm_required"),
                validate: (value) =>
                  value === password || t("reset_password.not_match"),
              }}
            />

            <button type="submit" className="reset-button">
              {t("reset_password.reset_button")}
            </button>
          </form>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ResetPasswordScreen;
